import { useState } from 'react';
import { navigate, onNavClick } from './router.js';

export default function Nav({ route }) {
  const [open, setOpen] = useState(false);
  const onHome = route.name === 'home';
  const link = (hash, label) => {
    // hash is like "#work"
    if (onHome) {
      return (
        <a href={hash} onClick={() => setOpen(false)}>{label}</a>
      );
    }
    // From a non-home page, route to home and then scroll to the anchor.
    const id = hash.replace(/^#/, '');
    return (
      <a
        href={'/' + hash}
        onClick={(e) => {
          e.preventDefault();
          setOpen(false);
          navigate('/');
          requestAnimationFrame(() => {
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          });
        }}
      >{label}</a>
    );
  };
  return (
    <nav className="nav">
      <a href="/" className="nav__brand" onClick={onNavClick}>
        <span>Ryan Marfone</span>
      </a>
      <div className={"nav__links" + (open ? ' is-open' : '')}>
        {link('#work', 'Work')}
        {link('#about', 'About')}
        {link('#contact', 'Contact')}
      </div>
      <div className="nav__right">
        <span className="nav__status" aria-label="Availability">
          <span className="nav__status-dot" />
          <span>Available</span>
          <span className="nav__status-sep">·</span>
          <span>Remote</span>
          <span className="nav__status-sep">·</span>
          <span>Houston, TX</span>
        </span>
        <button className="nav__burger" aria-label="Menu" onClick={() => setOpen(o => !o)}>
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
